import React from "react"
import Template from "../../components/Template"
import Translations from "../../../components/Translations"
import img1 from "../../images/indicators/indicators.jpg"

function PercentageDiff() {
    const Content = () => {
        return (
            <div className={`flex flex-col gap-5`}>
                <img src={img1} alt='/' className={`border border-gray-700 mt-5 mb-5 w-[20%]`}></img>
                <p className={`text-lg`}><Translations category={"docsPercantageDiff"} id={1}/></p>
                <p className={`text-lg`}><Translations category={"docsPercantageDiff"} id={2}/></p>
                <p className={`text-lg`}>
                    <Translations category={"docsPercantageDiff"} id={3}/>
                    <li><Translations category={"docsPercantageDiff"} id={4}/></li>
                    <li><Translations category={"docsPercantageDiff"} id={5}/></li>
                    <li><Translations category={"docsPercantageDiff"} id={6}/></li>
                </p>
                <p className={`text-lg`}><Translations category={"docsPercantageDiff"} id={7}/></p>
            </div>
        )
    }
    const config = {
        title: <Translations category={"docs"} id={28}/>,
        previousLink: '/docs/historical-min-max',
        previousTitle: <Translations category={"docs"} id={27}/>,
        nextLink: '/docs/moving-average-convergence-divergence',
        nextTitle: <Translations category={"docs"} id={29}/>,
        content: Content(),
    }

    return (
        <Template config={config}/>
    )
}

export default PercentageDiff